/** 针式打印模板 — 列表与编辑页共用的选项与映射 */

/** 后端打印样式枚举 CxmJolimarkTypeEnum */
export const CXM_JOLIMARK_TYPE_ENUM = {
  EnablePrintMatrix120_1: 'enable_print_matrix_120_1',
  EnablePrintMatrix241_1: 'enable_print_matrix_241_1',
  EnablePrintMatrix241_2: 'enable_print_matrix_241_2',
};

export const JOLIMARK_PRINT_LAYOUT_LABEL = {
  [CXM_JOLIMARK_TYPE_ENUM.EnablePrintMatrix120_1]: '120mm打印纸 一行一个货',
  [CXM_JOLIMARK_TYPE_ENUM.EnablePrintMatrix241_1]: '241mm打印纸 一行一个货',
  [CXM_JOLIMARK_TYPE_ENUM.EnablePrintMatrix241_2]: '241mm打印纸 一行两个货',
};

/** 从列表/详情记录解析打印样式枚举 */
export function getJolimarkTypeFromRecord(record) {
  if (!record) return undefined;
  return record.cxmJolimarkTypeEnum || (record.templateDetail && record.templateDetail.printStyle);
}

/** 打印样式展示文案 */
export function getPrintLayoutLabelFromRecord(record) {
  const type = getJolimarkTypeFromRecord(record);
  return (type && JOLIMARK_PRINT_LAYOUT_LABEL[type]) || '-';
}

export const PRINT_STYLE_VALUE = {
  V241_ONE: '241_one',
  V241_TWO: '241_two',
  V120_ONE: '120_one',
};

export const PRINT_STYLE_OPTIONS = [
  { value: PRINT_STYLE_VALUE.V241_ONE, label: '241mm打印纸 一行一个货' },
  { value: PRINT_STYLE_VALUE.V241_TWO, label: '241mm打印纸 一行两个货' },
  { value: PRINT_STYLE_VALUE.V120_ONE, label: '120mm打印纸 一行一个货' },
];

/** 配货单 productFieldList 字段枚举 */
export const MEMO_FIELD_OPTION_VALUE = {
  PACK_WEIGHT: 'packWeight',
  ORDER_NUMBER: 'orderNumber',
  SALE_NUMBER: 'saleNumber',
  PACK_STATUS: 'packStatus',
};

/** 配货单字段最多同时勾选数量 */
export const MEMO_FIELD_MAX_COUNT = 3;

/** 配货单字段勾选顺序 */
export const MEMO_FIELD_ORDER = [
  MEMO_FIELD_OPTION_VALUE.PACK_WEIGHT,
  MEMO_FIELD_OPTION_VALUE.ORDER_NUMBER,
  MEMO_FIELD_OPTION_VALUE.SALE_NUMBER,
  MEMO_FIELD_OPTION_VALUE.PACK_STATUS,
];

export const MEMO_FIELD_CHECKBOX_OPTIONS = [
  { value: MEMO_FIELD_OPTION_VALUE.PACK_WEIGHT, label: '规格' },
  { value: MEMO_FIELD_OPTION_VALUE.ORDER_NUMBER, label: '下单量' },
  { value: MEMO_FIELD_OPTION_VALUE.SALE_NUMBER, label: '销量' },
  { value: MEMO_FIELD_OPTION_VALUE.PACK_STATUS, label: '配货栏' },
];

export const PRINT_LAYOUT_TO_STYLE_VALUE = {
  '241mm打印纸 一行一个货': PRINT_STYLE_VALUE.V241_ONE,
  '241mm打印纸 一行两个货': PRINT_STYLE_VALUE.V241_TWO,
  '120mm打印纸 一行一个货': PRINT_STYLE_VALUE.V120_ONE,
};

export function getPrintStyleValueFromLayout(printLayout) {
  return PRINT_LAYOUT_TO_STYLE_VALUE[printLayout] || PRINT_STYLE_VALUE.V241_ONE;
}

/** 表单 printStyle → 后端 PrintStyle / CxmJolimarkTypeEnum */
export const PRINT_STYLE_VALUE_TO_API = {
  [PRINT_STYLE_VALUE.V241_ONE]: CXM_JOLIMARK_TYPE_ENUM.EnablePrintMatrix241_1,
  [PRINT_STYLE_VALUE.V241_TWO]: CXM_JOLIMARK_TYPE_ENUM.EnablePrintMatrix241_2,
  [PRINT_STYLE_VALUE.V120_ONE]: CXM_JOLIMARK_TYPE_ENUM.EnablePrintMatrix120_1,
};

export function toApiPrintStyle(uiValue) {
  return PRINT_STYLE_VALUE_TO_API[uiValue] || CXM_JOLIMARK_TYPE_ENUM.EnablePrintMatrix241_1;
}

/** 后端 PrintStyle → 表单 printStyle */
export const API_PRINT_STYLE_TO_VALUE = Object.entries(PRINT_STYLE_VALUE_TO_API).reduce(
  (acc, [ui, api]) => {
    acc[api] = ui;
    return acc;
  },
  {},
);

export function toUiPrintStyle(apiValue) {
  return API_PRINT_STYLE_TO_VALUE[apiValue] || PRINT_STYLE_VALUE.V241_ONE;
}

/** 头部/二维码图片对齐：表单小写 → 后端 Align 枚举 */
export const HEADER_IMAGE_ALIGN_TO_API = {
  left: 'LEFT',
  center: 'CENTER',
  right: 'RIGHT',
};

export const API_ALIGN_TO_HEADER_IMAGE = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
};

/** 配货单字段默认勾选：规格、销量 */
export function getDefaultMemoFieldKeys() {
  return [MEMO_FIELD_OPTION_VALUE.PACK_WEIGHT, MEMO_FIELD_OPTION_VALUE.SALE_NUMBER];
}

/** 按展示顺序截取配货单字段，并限制最大勾选数 */
export function pickMemoFieldKeys(fieldKeys) {
  const set = new Set(fieldKeys || []);
  return MEMO_FIELD_ORDER.filter((code) => set.has(code)).slice(0, MEMO_FIELD_MAX_COUNT);
}

/** 独立路由 path（与 home 中 Route 一致） */
export const STALL_DOT_MATRIX_DISTRIBUTION_EDIT_PATH =
  '/booth/stallManager/stallManagementDetail/stallDotMatrixDistributionEdit';

export const STALL_DOT_MATRIX_SALES_TEMPLATE_EDIT_PATH =
  '/booth/stallManager/stallManagementDetail/stallDotMatrixSalesTemplateEdit';
